export const NON_CUSTOMER_CUSTOMER_ID = 99999999999;
export const ALL_FACILITIES_GROUP_ID = '00000000-0000-0000-0000-000000000000';
